export default __webpack_public_path__ + "static/media/flag-eu.74ce93ce.svg";